/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'ecommerce/033-headset': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M487 280c0-44.454-30.694-81.868-72-92.179v-28.345C415 71.541 343.561 0 255.75 0S96.5 71.541 96.5 159.477v28.467C55.446 198.429 25 235.725 25 280c0 52.383 42.617 95 95 95h32c8.284 0 15-6.716 15-15V200c0-8.284-6.716-15-15-15h-25.5v-25.523C126.5 88.083 184.481 30 255.75 30S385 88.083 385 159.477V185h-25c-8.284 0-15 6.716-15 15v160c0 8.284 6.716 15 15 15h25v22.691c0 28.016-22.793 50.809-50.809 50.809h-17.83C309.941 430.179 292.486 417 272 417h-32c-26.355 0-47 21.084-47 48 0 25.916 21.084 47 47 47h32c21.386 0 39.01-13.884 44.897-33.5h17.295c44.558 0 80.809-36.25 80.809-80.809v-25.513C456.306 361.868 487 324.454 487 280zm-350 65h-17c-35.841 0-65-29.159-65-65s29.159-65 65-65h17zm135 137h-32c-9.374 0-17-7.626-17-17 0-11.817 8.552-18 17-18h32c9.374 0 17 7.626 17 17 0 11.817-8.552 18-17 18zm120-137h-17V215h17c35.841 0 65 29.159 65 65s-29.159 65-65 65z"/>'
  }
})
